import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductExclusionModal from '../../ProductExclusionModal';
import type { IneligibleProduct } from './types';

interface GradingValidationModalProps {
  ineligibleProducts: IneligibleProduct[];
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Warns that some selected products have no grading group or a non-matching one, and offers
 * to remove them and continue with the eligible cohort (BM-9210 req 17). Closing without
 * confirming leaves the module, so this passes its own `onCancel` rather than taking the
 * shared modal's default of treating ✕ as confirm.
 */
const GradingValidationModal: React.FC<GradingValidationModalProps> = ({ ineligibleProducts, onConfirm, onCancel }) => {
  const { t } = useTranslation('bulk-edit');

  return (
    <ProductExclusionModal
      title={t('MEASUREMENTS_MODULE.GRADING_MODAL_TITLE')}
      message={t('MEASUREMENTS_MODULE.GRADING_MODAL_MESSAGE')}
      products={ineligibleProducts}
      confirmLabel={t('MEASUREMENTS_MODULE.GRADING_MODAL_CONTINUE')}
      onConfirm={onConfirm}
      onClose={onCancel}
    />
  );
};

export default GradingValidationModal;
